import { render, staticRenderFns } from "./CombinationsWizard.vue?vue&type=template&id=a07d68ca&scoped=true"
import script from "./CombinationsWizard.vue?vue&type=script&lang=ts"
export * from "./CombinationsWizard.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsWizard.vue?vue&type=style&index=0&id=a07d68ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d68ca",
  null
  
)

export default component.exports